import { css } from 'styled-components';
import {
  getSpacing, getTypography, SpacingName, ThemedFunctor, BreakpointQueryName, TypographyName, FontWeight,
} from '@doveit/lego';

export const grid: ThemedFunctor = () => css`
  display: flex;
  flex-wrap: wrap;
`;

export const column: ThemedFunctor = ({
  theme,
}) => css`
  flex: 1 0 100%;

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    &:first-of-type {
      flex: 1 0 60%;
      padding-right: ${theme.spaceUnits.desktop.SMALL};
    }

    &:last-of-type {
      flex: 1 0 40%;
    }
  }
`;

export const videoWrapper: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
  overflow: hidden;
  padding-top: 56.25%;
  position: relative;

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    margin: 0;
  }
`;

export const singleCTA: ThemedFunctor = ({ theme }) => css`
  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    width: 20rem;
  }
`;

export const quote: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H4)}
  font-style: italic;
  text-align: center;
  color: ${theme.palettes.neutrals.medium};
`;

export const interviewCTA: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALL)}
  ${getTypography(theme, TypographyName.H4)}
  text-align: center;

  a {
    font-weight: ${FontWeight.BOLD};
    color: ${theme.palettes.brand.primary};
    text-decoration: underline;
  }
`;

export const stats: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.BIG)}
`;

export const heroMobileForm: ThemedFunctor = ({ theme }) => css`
  margin: 0 auto;
  max-width: 20rem;

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    display: none
  }
`;

export const heroDesktopForm: ThemedFunctor = ({ theme }) => css`
  display: none;

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    display: block
  }
`;

export const interviewItem: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, [SpacingName.MEDIUM, 0])}
  border-top: 1px solid ${theme.palettes.neutrals.lighter};

  &:first-child {
    border-top: 0;
  }
`;

export const agentPicture: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.margin(theme, [SpacingName.BIG, SpacingName.AUTO, 0])}
  display: block;
  height: 10rem;
  width: 10rem;
  border-radius: 100%;

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    height: 12rem;
    width: 12rem;
  }
`;

export const adv: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.BIG)}
  ${getSpacing.paddingTop(theme, SpacingName.BIG)}
  border-top: 1px solid ${theme.palettes.neutrals.light};
`;

export const valueBlock: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.padding(theme, [SpacingName.BIG, SpacingName.MEDIUM, SpacingName.MEDIUM])}
  position: relative;
`;

export const valueBlockLogo: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.margin(theme, [SpacingName.SMALL, SpacingName.MEDIUM, 0, 0])}
  position: absolute;
  width: 4.5rem;
  color: ${theme.palettes.brand.primary};
  top: 0;
  right: 0;
`;

export const valueBlockTitle: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.H3)}
  color: ${theme.palettes.brand.primary};
`;

export const valueBlockDescription: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALL)}
`;

export const carouselFrame: ThemedFunctor = ({ theme }) => css`
  position: relative;
  border-radius: 1.25rem;
  box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.1);
  background-color: ${theme.palettes.neutrals.lightest};
  border: 1px solid transparent;

  &::before,
  &::after {
    position: absolute;
    font-size: 7rem;
    color: ${theme.palettes.brand.primary};
    display: flex;
    width: 4rem;
    height: 4rem;
    z-index: ${theme.zIndex.inpage};
    align-items: center;
    justify-content: center;
    line-height: 1;
  }

  &::before {
      content: '“';
      top: 0;
      left: 0;
      transform: translateX(-40%) translateY(5%);
    }

    &::after {
      content: '”';
      bottom: 0;
      right: 0;
      transform: translateX(35%) translateY(105%);
    }

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    &::before,
    &::after {
      font-size: 10rem;
    }

    &::before {
      transform: translateX(-50%) translateY(25%);
    }

    &::after {
      transform: translateX(50%) translateY(125%);
    }
  }
`;

export const carouselInnerFrame: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.margin(theme, SpacingName.MEDIUM)}
  overflow: hidden;
`;
